// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__46aUx","logo":"style__logo__RXjDd"};